// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PSixVesselTonnage\ApiPSixVesselTonnage.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PSixVesselResult, PSixVesselResultData, PSixVesselResultOptions } from 'data/models/PSixVesselResult';

// PSixVesselTonnageData is the class that PSixVesselTonnage serializes to/from
export interface PSixVesselTonnageData {
    Id : number;
	
    PSixVesselResultId : number;
    TonnageTypeLookupId : number;
    TonnageUnitOfMeasurementFilterLookupId : number;
    VesselId : string | null;
    VesselResult : PSixVesselResultData | null;
    VesselResultId : number;
	
    CreatedOnUtc : /* ISO8601 */ string;
    Guid : /* GUID */ string;
    MeasureOfWeight : string | null;
    TonnageTypeLookupName : string | null;
    UnitOfMeasureLookupName : string | null;
}

// PSixVesselTonnageOptions is the class which may be passed to the PSixVesselTonnage constructor to define optional initial data values
export interface PSixVesselTonnageOptions {
    Id : number;
	
    PSixVesselResultId? : number;
    TonnageTypeLookupId? : number;
    TonnageUnitOfMeasurementFilterLookupId? : number;
    VesselId? : string | null;
    VesselResult? : PSixVesselResultOptions | null;
    VesselResultId? : number;
	
    CreatedOnUtc? : /* ISO8601 */ string;
    Guid? : /* GUID */ string;
    MeasureOfWeight? : string | null;
    TonnageTypeLookupName? : string | null;
    UnitOfMeasureLookupName? : string | null;
}

export class PSixVesselTonnage {
    public Id : DataSignal<number>;
	
    public PSixVesselResultId : DataSignal<number>;
    public TonnageTypeLookupId : DataSignal<number>;
    public TonnageUnitOfMeasurementFilterLookupId : DataSignal<number>;
    public VesselId : DataSignal<string | null>;
    public VesselResult : DataSignal<PSixVesselResult | null>;
    public VesselResultId : DataSignal<number>;
	
    public CreatedOnUtc : DataSignal<TZDate>;
    public Guid : DataSignal<string>;
    public MeasureOfWeight : DataSignal<string | null>;
    public TonnageTypeLookupName : DataSignal<string | null>;
    public UnitOfMeasureLookupName : DataSignal<string | null>;

    constructor();
    constructor(data : PSixVesselTonnageOptions);
    constructor(data: PSixVesselTonnageOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.PSixVesselResultId = jsonableObservable(S.value<number>(data && data.PSixVesselResultId !== undefined ? data.PSixVesselResultId : 0));
        this.TonnageTypeLookupId = jsonableObservable(S.value<number>(data && data.TonnageTypeLookupId !== undefined ? data.TonnageTypeLookupId : 0));
        this.TonnageUnitOfMeasurementFilterLookupId = jsonableObservable(S.value<number>(data && data.TonnageUnitOfMeasurementFilterLookupId !== undefined ? data.TonnageUnitOfMeasurementFilterLookupId : 0));
        this.VesselId = jsonableObservable(S.value<string | null>(data && data.VesselId !== undefined ? data.VesselId : null));
        this.VesselResult = S.value<PSixVesselResult | null>(null);
        this.VesselResultId = jsonableObservable(S.value<number>(data && data.VesselResultId !== undefined ? data.VesselResultId : 0));
	    
        this.CreatedOnUtc = jsonableObservable(S.value<TZDate>(data && data.CreatedOnUtc !== undefined ? new TZDate(data.CreatedOnUtc) : new TZDate(0), TZDate.eq));
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.MeasureOfWeight = jsonableObservable(S.value<string | null>(data && data.MeasureOfWeight !== undefined ? data.MeasureOfWeight : null));
        this.TonnageTypeLookupName = jsonableObservable(S.value<string | null>(data && data.TonnageTypeLookupName !== undefined ? data.TonnageTypeLookupName : null));
        this.UnitOfMeasureLookupName = jsonableObservable(S.value<string | null>(data && data.UnitOfMeasureLookupName !== undefined ? data.UnitOfMeasureLookupName : null));
    }

    static key(obj : PSixVesselTonnage) {
        return obj.Id();
    }
    
    static dataKey(obj : PSixVesselTonnageOptions) {
        return obj.Id;
    }

    static update(obj : PSixVesselTonnage, data : PSixVesselTonnageOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.PSixVesselResultId !== undefined) obj.PSixVesselResultId(data.PSixVesselResultId);
            if (data.TonnageTypeLookupId !== undefined) obj.TonnageTypeLookupId(data.TonnageTypeLookupId);
            if (data.TonnageUnitOfMeasurementFilterLookupId !== undefined) obj.TonnageUnitOfMeasurementFilterLookupId(data.TonnageUnitOfMeasurementFilterLookupId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
            if (data.VesselResultId !== undefined) obj.VesselResultId(data.VesselResultId);
	        
            if (data.CreatedOnUtc !== undefined) obj.CreatedOnUtc(new TZDate(data.CreatedOnUtc));
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.MeasureOfWeight !== undefined) obj.MeasureOfWeight(data.MeasureOfWeight);
            if (data.TonnageTypeLookupName !== undefined) obj.TonnageTypeLookupName(data.TonnageTypeLookupName);
            if (data.UnitOfMeasureLookupName !== undefined) obj.UnitOfMeasureLookupName(data.UnitOfMeasureLookupName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PSixVesselTonnage.ts